import { render } from "./StudentListTable.vue?vue&type=template&id=00bfa15c&scoped=true&ts=true"
import script from "./StudentListTable.vue?vue&type=script&lang=ts"
export * from "./StudentListTable.vue?vue&type=script&lang=ts"

import "./StudentListTable.vue?vue&type=style&index=0&id=00bfa15c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bfa15c"]])

export default __exports__